"use client";

import ScrollReveals from "@/components/ScrollReveals";

// Injected into every sub-page via SiteHeader.
// Provides: animated gradient aurora, sticky mobile booking CTA, scroll-reveal wiring.
export default function SubpageEffects() {
  return (
    <>
      <ScrollReveals />
      <div className="sp-aurora" aria-hidden="true">
        <span className="spa-1" />
        <span className="spa-2" />
      </div>
      <a href="/apply/" className="sticky-cta">Book a free call</a>
    </>
  );
}
